function isPrivateIpv4(hostname: string): boolean {
  const parts = hostname.split('.').map(Number)
  if (
    parts.length !== 4 ||
    parts.some((part) => !Number.isInteger(part) || part < 0 || part > 255)
  ) {
    return false
  }

  const [first = 0, second = 0] = parts
  return (
    first === 0 ||
    first === 10 ||
    first === 127 ||
    (first === 100 && second >= 64 && second <= 127) ||
    (first === 169 && second === 254) ||
    (first === 172 && second >= 16 && second <= 31) ||
    (first === 192 && second === 168) ||
    (first === 198 && (second === 18 || second === 19)) ||
    first >= 224
  )
}

function isPrivateHostname(hostname: string): boolean {
  const normalized = hostname
    .toLowerCase()
    .replace(/^\[|\]$/g, '')
    .replace(/\.$/, '')
  if (
    normalized === 'localhost' ||
    normalized.endsWith('.localhost') ||
    normalized.endsWith('.local') ||
    normalized.endsWith('.internal')
  ) {
    return true
  }
  if (isPrivateIpv4(normalized)) return true
  if (normalized.startsWith('::ffff:')) {
    const mapped = normalized.slice('::ffff:'.length)
    if (isPrivateIpv4(mapped)) return true
    const hex = mapped.match(/^([0-9a-f]{1,4}):([0-9a-f]{1,4})$/)
    if (hex) {
      const high = Number.parseInt(hex[1]!, 16)
      const low = Number.parseInt(hex[2]!, 16)
      const ipv4 = `${high >> 8}.${high & 255}.${low >> 8}.${low & 255}`
      if (isPrivateIpv4(ipv4)) return true
    }
  }

  const isIpv6 = normalized.includes(':')
  return (
    normalized === '::' ||
    normalized === '::1' ||
    (isIpv6 &&
      (normalized.startsWith('fc') || normalized.startsWith('fd') || /^fe[89ab]/.test(normalized)))
  )
}

export function webhookUrlError(value: string): string | undefined {
  const trimmed = value.trim()
  if (!trimmed) return 'Informe a URL do endpoint.'

  let url: URL
  try {
    url = new URL(trimmed)
  } catch {
    return 'Informe uma URL válida.'
  }

  if (url.protocol !== 'https:') {
    return 'Use HTTPS para proteger os eventos e o secret.'
  }
  if (url.username || url.password) {
    return 'Não inclua usuário ou senha na URL.'
  }
  if (isPrivateHostname(url.hostname)) {
    return 'Use um domínio público; localhost e redes privadas não são aceitos.'
  }
  return undefined
}
